<template>
  <div class="role-card app__card">
    <div class="role-card__details">
      <h2 class="role-card__title">
        {{ role.name | formatUserRole }}
      </h2>
      <p class="role-card__description">
        {{ role.description }}
      </p>
    </div>
    <div class="role-card__actions">
      <permission-wrapper
        skip-alert
        page-name="roles"
        resource-name="role"
        action-name="read_foreign">
        <button
          v-ripple
          class="role-card__btn app__button-raised"
          :disabled="formMixin.isDisabled"
          @click="$router.push({
            name: vueRoutes.roleDetails.name,
            params: { id: role.id },
          })"
        >
          {{ 'role-card.btn-show' | globalize }}
        </button>
      </permission-wrapper>
    </div>
  </div>
</template>

<script>
import FormMixin from '@/vue/mixins/form.mixin'
import { RoleRecord } from '@/js/records/entities/role.record'
import { vueRoutes } from '@/vue-router/routes'
import PermissionWrapper from '@/vue/common/permission-wrapper'

export default {
  name: 'role-card',
  components: {
    PermissionWrapper,
  },
  mixins: [ FormMixin ],
  props: {
    role: {
      type: RoleRecord,
      required: true,
    },
  },
  data () {
    return {
      vueRoutes,
    }
  },
}
</script>

<style lang="scss" scoped>
.role-card {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 2rem;
  padding: 3rem 4rem;
}

.role-card__details {
  display: flex;
  flex-direction: column;
  gap: 3.2rem;
}
</style>
